module.exports = __webpack_public_path__ + "img/goin.097e2f54.png";